// extracted by mini-css-extract-plugin
module.exports = {"noTransform":"customMenuList_noTransform__2mc1q","alert-margin":"customMenuList_alert-margin__2ZYdP"};